import { BehaviorSubject } from 'rxjs';
import { db$, dispatch } from 'nike-re-framejs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import Immutable, { Map } from 'immutable';
import { extractBetslipPicks } from './subs';
import { nuiCtx } from '../../common/initialization';

export const currentPicks$ = new BehaviorSubject(Map());

db$.pipe(
    map((db: Map<string, any>) => {
        const betslips = db.getIn(['betslip', 'server', 'betslips']) || db.getIn(['server', 'betslips']);
        if (!betslips) {
            return null;
        }
        const betslipIndex = db.getIn(['betslip', 'activeBetslipIndex'], 0);

        return betslips.find(b => b.get('index') === betslipIndex);
    }),
    distinctUntilChanged(),
    filter(betslip => !!betslip),
    map(betslip => {
        return extractBetslipPicks(betslip);
    }),
    distinctUntilChanged((before: Map<string, any>, after: Map<string, any>) => {
        return Immutable.is(before.keySeq().toSet(), after.keySeq().toSet());
    })
).subscribe(currentPicks$);

export function addPick({ betId, selectionCode, odds, positionId, positionCode, ...rest }) {
    const cmd = [
        nuiCtx.platform === 'mobile' ? 'AddPickMobile' : 'AddPick',
        {
            betId,
            selectionCode,
            odds,
            positionId,
            positionCode,
            ...rest
        }
    ];
    dispatch(['betslip.cmd', cmd]);
}

export function removePick({ betId }) {
    const cmd = ['RemovePick', { betId }];
    dispatch(['betslip.cmd', cmd]);
}
